import { Injectable } from '@angular/core';
import { StaticMemory } from './static_memory';
import { ShopService } from '../pages/shop/shop.service';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ApiUtilService {
  public test: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public test$ = this.test.asObservable();

  constructor(private _service: ShopService) {}

  postOfferApply(value: any): void {
    const context = this;
    let body: any = {
      channel: 'NECOM',
      subProductId: value?._id,
      stockId: value?.stockInfo?._id,
      selectedQuantity: value.selectedQuantity,
      customerProfileId: StaticMemory.profileDetails.id,
      warehouseId: StaticMemory.serAreaObject?.warehouseId,
      invoiceValue: value?.offerType ? value?.invoiceValue : null,
      type: value?.offerType ? value?.offerType : null,
    };
    context._service.postOfferApply(body).subscribe({
      next: (success: any) => {
        if (success.status) {
          this.test.next(true);
        } else {
          if (success.code === 4742) {
            this.test.next(true);
          }
        }
      },
      error(error: any) {},
    });
  }
}
